<div>
    <div class="absolute inset-0 bg-primary"></div>

    <div class="relative flex min-h-screen items-center justify-center px-6 py-10 dark:bg-[#060818] sm:px-16">
        <div
            class="relative w-full max-w-[870px] rounded-md bg-[linear-gradient(45deg,#fff9f9_0%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,_#fff9f9_100%)] p-2 dark:bg-[linear-gradient(52.22deg,#0E1726_0%,rgba(14,23,38,0)_18.66%,rgba(14,23,38,0)_51.04%,rgba(14,23,38,0)_80.07%,#0E1726_100%)]"
        >
            <div class="relative flex flex-col justify-center rounded-md bg-white/60 px-6 py-20 backdrop-blur-lg dark:bg-black/50 lg:min-h-[758px]">
                <div class="absolute end-6 top-6">
                    <div class="dropdown">
                        <div hlMenu>
                            <button
                                type="button"
                                hlMenuButton
                                class="flex items-center gap-2.5 rounded-lg border border-white-dark/30 bg-white px-2 py-1.5 text-white-dark hover:border-primary hover:text-primary dark:bg-black"
                            >
                                <div>
                                    <img
                                        [src]="'/assets/images/flags/'+ store.locale.toUpperCase() + '.svg'"
                                        alt="image"
                                        class="h-5 w-5 rounded-full object-cover"
                                    />
                                </div>
                                <div class="text-base font-bold uppercase">{{ store.locale }}</div>
                                <span class="shrink-0">
                                    <icon-caret-down />
                                </span>
                            </button>
                            <ul
                                *hlMenuItems
                                @toggleAnimation
                                class="top-11 grid w-[280px] grid-cols-2 gap-2 !px-2 font-semibold text-dark dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2"
                            >
                                <li *ngFor="let item of store.languageList;">
                                    <button
                                        *hlMenuItem="let menuItem"
                                        type="button"
                                        class="w-full hover:text-primary"
                                        [ngClass]="{ 'bg-primary/10 text-primary': translate.currentLang === item.code }"
                                        (click)="changeLanguage(item)"
                                    >
                                        <img
                                            class="h-5 w-5 rounded-full object-cover"
                                            [src]="'/assets/images/flags/'+ item.code.toUpperCase() + '.svg'"
                                            alt=""
                                        />
                                        <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="mx-auto w-full max-w-[440px]">
                    <div class="mb-10">
                        <h1 class="text-3xl font-extrabold uppercase !leading-snug text-primary md:text-4xl">Sign Up</h1>
                        <p class="text-base font-bold leading-normal text-white-dark">Enter your email and password to register</p>
                    </div>
                    <form class="space-y-5 dark:text-white" (submit)="router.navigate(['/'])">
                        <div>
                            <label for="Name">Name</label>
                            <div class="relative text-white-dark">
                                <input id="Name" type="text" placeholder="Enter Name" class="form-input ps-10 placeholder:text-white-dark" />
                                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                    <icon-user [fill]="true" />
                                </span>
                            </div>
                        </div>
                        <div>
                            <label for="Email">Email</label>
                            <div class="relative text-white-dark">
                                <input id="Email" type="email" placeholder="Enter Email" class="form-input ps-10 placeholder:text-white-dark" />
                                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                    <icon-mail [fill]="true" />
                                </span>
                            </div>
                        </div>
                        <div>
                            <label for="Password">Password</label>
                            <div class="relative text-white-dark">
                                <input id="Password" type="password" placeholder="Enter Password" class="form-input ps-10 placeholder:text-white-dark" />
                                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                    <icon-lock-dots [fill]="true" />
                                </span>
                            </div>
                        </div>
                        <div>
                            <label class="flex cursor-pointer items-center">
                                <input type="checkbox" class="form-checkbox bg-white dark:bg-black" />
                                <span class="text-white-dark">Subscribe to weekly newsletter</span>
                            </label>
                        </div>
                        <button type="submit" class="btn btn-gradient !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]">
                            Sign Up
                        </button>
                    </form>
                    <div class="relative my-7 text-center md:mb-9">
                        <span class="absolute inset-x-0 top-1/2 h-px w-full -translate-y-1/2 bg-white-light dark:bg-white-dark"></span>
                        <span class="relative bg-white px-2 font-bold uppercase text-white-dark dark:bg-dark dark:text-white-light">or</span>
                    </div>
                    <div class="mb-10 md:mb-[60px]">
                        <ul class="flex justify-center gap-3.5 text-white">
                            <li>
                                <a
                                    href="javascript:"
                                    class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
                                    style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
                                >
                                    <icon-instagram />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:"
                                    class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
                                    style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
                                >
                                    <icon-facebook-circle />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:"
                                    class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
                                    style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
                                >
                                    <icon-twitter [fill]="true" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="javascript:"
                                    class="inline-flex h-8 w-8 items-center justify-center rounded-full p-0 transition hover:scale-110"
                                    style="background: linear-gradient(135deg, rgba(239, 18, 98, 1) 0%, rgba(67, 97, 238, 1) 100%)"
                                >
                                    <icon-google />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="text-center dark:text-white">
                        Already have an account ?
                        <a routerLink="/auth/signin" class="uppercase text-primary underline transition hover:text-black dark:hover:text-white"> SIGN IN </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
